<template>
  <su-page>
    <el-row class="mt30" slot="content">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
        <el-form-item label="考点名称" prop="name">
          <el-input
              v-model="queryParams.keyword"
              placeholder="请输入"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
<!--      @selection-change="handleSelectionChange"-->
      <el-table v-loading="loading" :data="symptomList" class="mt20" :header-cell-style="{backgroundColor:'#F3F4F8'}">
<!--        <el-table-column type="selection" width="55" align="center"/>-->
<!--        <el-table-column label="手机号" prop="mobile" />-->
        <el-table-column label="考点名称" prop="firm"/>
<!--        <el-table-column label="考点联系人" prop="name" />-->
<!--        <el-table-column label="资料费" prop="exam_fee"/>-->
<!--        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                v-hasPermi="['ybf:symptom:edit']"
            >修改</el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                v-hasPermi="['ybf:symptom:remove']"
            >删除</el-button>
          </template>
        </el-table-column>-->
      </el-table>
<!--      <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
      />-->
    </el-row>
  </su-page>
</template>
<script>

import {address_list} from "@/api/api";

export default {
  name: "outline",
  data() {
    return {
      // 列表加载
      loading: false,
      // 显示搜索条件
      showSearch: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
      },
      symptomList: [],
      // 总条数
      total: 0,
    }
  },
  created() {
    this.getList()
  },
  mounted() {

  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.keyword = ''
      this.handleQuery();
    },
    /** 查询辨症列表 */
    getList() {
      this.loading = true;
      address_list(this.queryParams).then(response => {
        if (response.status === 200){
          this.symptomList = response.data.list
        }
        this.loading = false;
      });
    },
  }
}
</script>


<style scoped lang="scss">

</style>
